class WaterFountainLayer extends Layer {

  constructor(mapGL, isVisible = false) {
    super(mapGL, isVisible);

    this.name = 'waterfountain';
    this.minZoom = 12;
    this.layerIds = ['waterfountain'];

    this.isClickable = false;

    this.load();
  }

  load() {
    this.mapGL.getMapObject().addSource(this.name + '-source', {
      'type': 'geojson',
      'data' : CACHE_URL + '/getLayer?action=load&layer=waterFountain'
    });

    this.mapGL.getMapObject().addLayer({
      'id': this.layerIds[0],
      'type': 'symbol',
      'source': this.name + '-source',
      'layout': {
        'icon-image': this.name,
        'icon-allow-overlap': true,
        'visibility': this.isVisible ? 'visible' : 'none'
      },
      'minzoom': this.minZoom,
    });
  }
}
